// extracted by mini-css-extract-plugin
module.exports = {"root":"MicControl_root__rALi_"};